import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const CourseCard = ({ course, onCompare, isComparing, onViewDetails }) => {
  const {
    id,
    title,
    category,
    duration,
    level,
    image,
    description,
    certification,
    rating,
    mode,
    isPopular,
    isFeatured
  } = course;

  return (
    <div className="bg-card rounded-xl shadow-card hover:shadow-card-lg transition-all duration-300 border border-border overflow-hidden group">
      {/* Image Section */}
      <div className="relative h-48 overflow-hidden">
        <Image
          src={image}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        
        {/* Badges */}
        <div className="absolute top-3 left-3 flex flex-wrap gap-2">
          {isPopular && (
            <span className="bg-accent text-accent-foreground px-2 py-1 rounded-full text-xs font-medium">
              Popular
            </span>
          )}
          {isFeatured && (
            <span className="bg-primary text-primary-foreground px-2 py-1 rounded-full text-xs font-medium">
              Featured
            </span>
          )}
          <span className="bg-background/90 text-foreground px-2 py-1 rounded-full text-xs font-medium">
            {level}
          </span>
        </div>

        {/* Compare Button */}
        <button
          onClick={() => onCompare(course)}
          className={`absolute top-3 right-3 p-2 rounded-full transition-all duration-200 ${
            isComparing 
              ? 'bg-primary text-primary-foreground' 
              : 'bg-background/90 text-foreground hover:bg-primary hover:text-primary-foreground'
          }`}
          title={isComparing ? 'Remove from comparison' : 'Add to comparison'}
        >
          <Icon name="GitCompare" size={16} />
        </button>
      </div>
      {/* Content Section */}
      <div className="p-6">
        {/* Header */}
        <div className="mb-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-primary font-medium">{category}</span>
            <div className="flex items-center space-x-1">
              <Icon name="Star" size={14} className="text-warning fill-current" />
              <span className="text-sm font-medium">{rating}</span>
            </div>
          </div>
          <h3 className="text-lg font-semibold text-foreground mb-2 line-clamp-2">
            {title}
          </h3>
          <p className="text-sm text-muted-foreground line-clamp-2">
            {description}
          </p>
        </div>

        {/* Course Details */}
        <div className="space-y-3 mb-4">
          <div className="flex items-center justify-between text-sm">
            <div className="flex items-center space-x-2">
              <Icon name="Award" size={14} className="text-muted-foreground" />
              <span className="text-muted-foreground">Certification:</span>
            </div>
            <span className="font-medium">{certification}</span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex space-x-2">
          <Button
            variant="outline"
            size="sm"
            fullWidth
            iconName="Eye"
            iconPosition="left"
            onClick={() => onViewDetails(course)}
          >
            View Details
          </Button>
          <Button
            variant="default"
            size="sm"
            fullWidth
            iconName="UserPlus"
            iconPosition="left"
            asChild
          >
            <a
              href="https://karumottiportal.ac.ke/Account/StudentApplication?returnUrl=%2FAppAdmin"
              target="_blank"
              rel="noopener noreferrer"
            >
              Apply Now
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;